<template>
    <v-container fluid>
        <v-row v-if="isLoading">
            <v-col>
                <loading-spinner></loading-spinner>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
                <editor-card :value="post.content" @update-content="updateContent">
                    <template v-slot:card-header>
                        <card-header :title="titles.write"></card-header>
                    </template>
                    
                    <template v-slot:header>
                        <v-row align="center">
                            <v-col cols="1">
                                <label class="d-flex text-body-1 align-self-center">{{ titles.editor }}</label>
                            </v-col>
                            <v-col cols="11">
                                <v-text-field v-model="post.title" dense></v-text-field>
                            </v-col>
                        </v-row>
                    </template>

                    <!-- 첨부파일 -->
                    <template v-slot:bottom-content>
                        <v-row align="center" class="mt-2">
                            <v-col cols="12" class="d-flex flex-row align-center">
                                <label class="text-body-1 pa-2">{{ $t('label.attachment') }}</label>
                                <file-input class="flex-grow-1 ml-2" :key="post.idx || 'new'"
                                    :initialFilePath="post.file_path || ''" :category="'board'"
                                    :acceptExtensions="['pdf', 'jpg', 'jpeg', 'png', 'gif']"
                                    @update-saved-file-path="updateFilePath"
                                    @update-saved-file-name="updateFileName"></file-input>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                                <span class="text-caption grey--text">{{ $t('txt.attachment_hint') }}</span>
                            </v-col>
                        </v-row>
                    </template>

                    <!-- 버튼 영역 -->
                    <template v-slot:bottom-buttons>
                        <div class="d-flex justify-space-between mt-10 mb-5">
                            <custom-button 
                            @click="goBack" 
                            color="black" 
                            :label="buttons.close" 
                            size="lg" 
                            gradient
                            rounded
                            ></custom-button>
                                
                            <custom-button 
                            @click="handleSubmit" 
                            color="primary" 
                            :label="buttons.submit" 
                            size="lg" 
                            gradient
                            rounded
                            ></custom-button>
                        </div>
                    </template>
                </editor-card>
            </v-col>
        </v-row>


    </v-container>
</template>

<script>
import EditorCard from "@/components/common/Cards/EditorCard.vue";
import { membernewsLabel } from "@/views/BoardView/label";
import { success, savePopup } from "@/views/BoardView/popups";
import { boardApi } from "@/api/api";
import CardHeader from '@/components/cards/CardHeader.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';
import FileInput from '@/components/common/input/FileInput.vue';

export default {
    components: {
        EditorCard,
        CardHeader,
        LoadingSpinner,
        CustomButton,
        FileInput,
    },
    props: {
        idx: {
            type: [String, Number],
            required: false,
        }
    },
    data() {
        return {
            titles: membernewsLabel.titles,
            buttons: membernewsLabel.buttons,
            isLoading: false,
            post: {
                board_idx: 2,
                title: null,
                content: null,
                file_path: null,
                down_file_name: null,
            }
        }
    },
    methods: {
        toMembernewList() {
            this.$router.push("/posts/membernews");
        },
        goBack() {
            this.$router.go(-1);
        },
        async handleSubmit() {
            const isConfirmed = await savePopup();
            if (!isConfirmed) return;
            
            const isCreate = this.idx == null;
            let isSuccess;
            
            if (isCreate) {
                isSuccess = await this.createPost(this.post);
            } else {
                isSuccess = await this.updatePost(this.post);
            }
            
            if (isSuccess) {
                await success();
                await this.toMembernewList();
            }
        },
        async createPost(post) {
            try {
                this.isLoading = true;
                const response = await boardApi.createPost(post);
                return response && response.status === 201;
            } catch {
                return false;
            } finally {
                this.isLoading = false;
            }
        },
        async updatePost(post) {
            try {
                this.isLoading = true;
                const response = await boardApi.updatePost(post);
                return response && response.status === 200;
            } catch {
                return false;
            } finally {
                this.isLoading = false;
            }
        },
        async fetchPost() {
            this.isLoading = true;
            try {
                const response = await boardApi.getPost({ idx: this.idx });
                if (response && response.status === 200) {
                    this.post = response.data.response;
                    return true;
                }
                return false;
            } catch {
                alert("요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.");
                this.goBack();
                return false;
            } finally {
                this.isLoading = false;
            }
        },
        updateContent(newValue) {
            this.post.content = newValue;
        },
        updateFilePath(path) {
            this.$set(this.post, 'file_path', path || null);
        },
        updateFileName(name) {
            this.$set(this.post, 'down_file_name', name || null);
        },
    },
    mounted() {
        if (this.idx != null) {
            this.fetchPost();
        }
    }
};
</script>

<style scoped>
</style>